import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

class PAUTInspectionForm extends Form {
	state = {
		data: {
			jointNo: '',
			welderId: '',
			sch: '',
			dia: '',
			thickness: '',
			scanLength: '',
			start: '',
			end: '',
			length: '',
			amplitude: '',
			type: '',
			result: '',
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		jointNo: Joi.string().min(3).required().label('Joint Number'),
		welderId: Joi.string().min(3).required().label('Welder ID'),
		sch: Joi.string().required().label('SCH'),
		dia: Joi.string().required().label('Dia'),
		thickness: Joi.number().positive().required().label('Thickness'),
		scanLength: Joi.number().positive().required().label('Scan Length'),
		start: Joi.string().min(3).required().label('Start'),
		end: Joi.string().min(3).required().label('End'),
		length: Joi.string().min(3).required().label('Length'),
		amplitude: Joi.string().min(3).required().label('Amplitude'),
		type: Joi.string().min(3).required().label('Type'),
		result: Joi.string().min(3).required().label('Result'),
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data);

		this.setState({
			data: {
				jointNo: '',
				welderId: '',
				sch: '',
				dia: '',
				thickness: '',
				scanLength: '',
				start: '',
				end: '',
				length: '',
				amplitude: '',
				type: '',
				result: '',
			},
		});
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'jointNo',
							label: 'Joint Number',
							placeholder: 'Enter Joint Number',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'welderId',
							label: 'Welder ID',
							placeholder: 'e.g. Enter Welder ID',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'sch',
							label: 'SCH',
							placeholder: 'Enter SCH',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							name: 'dia',
							type: 'text',
							label: 'Dia',
							placeholder: 'Enter Dia',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							name: 'thickness',
							type: 'number',
							label: 'Thickness',
							placeholder: 'Enter Thickness',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'scanLength',
							label: 'Scan Length',
							placeholder: 'Enter Scan Length',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'start',
							label: 'Start',
							placeholder: 'Enter Start',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'end',
							label: 'End',
							placeholder: 'Enter End',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'length',
							label: 'Length',
							placeholder: 'Enter Length',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'amplitude',
							label: 'Amplitude',
							placeholder: 'Enter Amplitude',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'type',
							label: 'Type',
							placeholder: 'Enter Type',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'result',
							label: 'Result',
							placeholder: 'Enter Result',
						})}
					</div>
				</div>

				{this.renderButton('Submit')}
			</form>
		);
	}
}

export default PAUTInspectionForm;
